export default {
	failedValidation(errors) {
		if (errors.has(this.name)) {
			this.errorMessage = errors.first(this.name);
			this.hasError = true;
		} else {
			this.errorMessage = null;
			this.hasError = false;
		}
	},
	passedValidation() {
		this.errorMessage = null;
		this.hasError = false;
	},
	resetValidation() {
		this.errorMessage = null;
		this.hasError = false;
	}
}



// WEBPACK FOOTER //
// ./src/components/form/events.js